<div class="email-confirmed-message darkblue-gradient-bg white-font text-center" *ngIf="emailConfirmed">
    <p>
        <i class="fa fa-check"></i>
        <strong>
            Seu e-mail foi confirmado com sucesso!
        </strong> Faça login e prepare-se para amplificar suas finanças.
    </p>
</div>
<div class="email-not-confirmed-message orange-gradient-bg white-font text-center" *ngIf="emailNotConfirmed">
    <p>
        <strong>
            Por favor, confirme seu e-mail.
        </strong>
    </p>
</div>

<icp-splitted-screen [fullContainer]="true" [contrastSide]="contrastSide">
    <ng-container left-content>
        <icp-carousel [images]="images"></icp-carousel>
    </ng-container>
    <ng-container right-content>
        <icp-onboarding
            [actions]="actions"
            [disabled]="form.invalid"
            (onClickButton)="submitForm()"
        >

            <ng-container form-content>
                <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)" class="form-horizontal">
                    <div class="input-group">
                        <icp-input
                            id="email"
                            name="email"
                            label="E-mail"
                            placeholder="Digite seu e-mail"
                            type="email"
                            formControlName="email"
                            [messageError]="formErrors.email"
                        ></icp-input>
                    </div>
                    <div class="input-group">
                        <icp-input
                            id="password"
                            name="password"
                            label="Senha"
                            placeholder="Digite sua senha"
                            type="password"
                            formControlName="password"
                            [messageError]="formErrors.password"
                            (keyup.enter)="submitForm()"
                        ></icp-input>
                    </div>
                </form>
                <div class="col-sm-12 recover-password-link">
                    <a routerLink="/forgot-password" class="desktop">Esqueci minha senha</a>
                    <a routerLink="/forgot-password" class="mobile">Esqueci a senha</a>
                </div>
            </ng-container>
        </icp-onboarding>
    </ng-container>
</icp-splitted-screen>
